/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import ApiUtils from 'api/ApiUtils';
import React, {useState} from 'react';
import {Button, Col, Form, Row} from 'react-bootstrap';
import categoryImagePlaceholder from 'assets/images/default-placeholder.jpg';
import {type VenueFormProps, type CategoryStatusList} from 'utils/TypeConfig';
import {useFormik} from 'formik';

import * as Yup from 'yup';
import {toast} from 'react-toastify';
import TooltipWithInfoIcon from 'Common/InfoTool';
import {tooltipMessage} from 'utils/Tooltips';
import {variables} from 'utils/constant';
const SuggestedVenueForm: React.FC<VenueFormProps> = ({
  handleClose,
  setIsEditCategory,
  setIsAddCategory,
  editVenue,
}) => {
  console.log('🚀 ~ editVenue:', editVenue);
  const [status] = useState([
    {id: variables.CLUB_ACTIVE_STATUS_ID, name: variables.CLUB_ACTIVE_STATUS},
    {
      id: variables.CLUB_INACTIVE_STATUS_ID,
      name: variables.CLUB_INACTIVE_STATUS,
    },
  ]);

  const [imageDisplay, setImageDisplay] = useState<string>();

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editVenue?.name !== '' ? editVenue?.name : '',
      image: editVenue?.image !== '' ? editVenue?.image : undefined,
      is_active: editVenue?.is_active !== '' ? editVenue?.is_active : 1,
      // parent_id:
      //   editVenue?.parent_id !== '' ? editVenue?.parent_id : null,
      // status: editVenue?.status !== '' ? editVenue?.status : '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Venue name is required'),
      // parent_id: Yup.string().notRequired(),
      image: Yup.mixed().required('Image is required'),
      is_active: Yup.number().required('Status is required'),
    }),
    onSubmit: async (values: any): Promise<void> => {
      console.log('🚀 ~ onSubmit: ~ values:', values);

      try {
        const formData = {
          name: values.name,
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          // status: values.status,
          ...(editVenue?.id
            ? {is_active: editVenue?.is_active}
            : {is_active: 1}),
          // parent_id: values.parent_id,
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          ...(editVenue?.id ? {id: editVenue?.id} : {}),
          ...(typeof values?.image !== 'string' ? {image: values?.image} : {}),
          // brand: selectedBrandOption.map((brand: any, index: number) => ({
          //   id: brand.value,
          // })),
        };
        // if (typeof values?.image !== 'string' && values?.image) {
        //   (formData as any).image = values?.image;
        // }
        console.log('🚀 ~ onSubmit: ~ formData:', formData);
        try {
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          const response: any = editVenue?.id
            ? await ApiUtils.updateVenue(formData)
            : await ApiUtils.addVenue(formData);
          // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/strict-boolean-expressions
          if (setIsEditCategory) {
            setIsEditCategory((prev: boolean) => !prev);
          }
          if (setIsAddCategory) {
            setIsAddCategory((prev: boolean) => !prev);
          }
          handleClose();
          toast.success(response?.message);
          // void getCategoryList();
        } catch (error: any) {
          toast.error(error?.response?.data?.message);
        }
      } catch (err: any) {
        toast.error(err);
      }
    },
  });

  const handleImage = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const file = e.target.files?.[0];

    if (file !== null && file) {
      const validImageTypes = [
        'image/jpeg',
        'image/png',
        'image/jpg',
        'image/webp',
      ];

      if (!validImageTypes.includes(file?.type)) {
        // console.error(
        //   'Invalid file type. Please upload an image of type: jpeg, png, jpg, gif, svg, webp. 111111',
        // );
        alert(
          'Invalid file type. Please upload an image of type: jpeg, png, jpg,webp',
        );
        return; // Exit the function if the file type is not valid
      }

      const objectUrl: string = URL.createObjectURL(file);
      setImageDisplay(objectUrl);
      console.log('🚀 ~ handleImage ~ objectUrl:', objectUrl, file);

      validation.setFieldValue('image', file);
    }
  };

  console.log('🚀 ~ handleImage ~ validation:', validation.values);

  // console.log(editVenue?.id, 'categoryList');
  return (
    <div>
      <Form
        className="tablelist-form"
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit();
        }}>
        <Row>
          <div
            id="alert-error-msg"
            className="d-none alert alert-danger py-2"></div>
          <input type="hidden" id="id-field" />
          <Col
            lg={12}
            className="d-flex justify-content-center align-items-center">
            <div className="mb-3 category-img">
              <label
                htmlFor="category-image-input"
                className="form-label d-block text-center">
                Image <span className="text-danger">*</span>
              </label>

              <div className="avatar-upload">
                <div className="avatar-edit">
                  <input
                    type="file"
                    id="imageUpload"
                    onChange={handleImage}
                    accept="image/jpeg, image/png, image/jpg, image/gif, image/svg+xml, image/webp"
                  />
                  <label
                    htmlFor="imageUpload"
                    className="image-upload-cam d-flex justify-content-center align-items-center">
                    <i className="ri-image-fill"></i>
                  </label>
                </div>
                <div className="avatar-preview">
                  <img
                    className="preview-select-img img-responsive img-circle"
                    id="imagePreview"
                    alt="User profile picture"
                    src={
                      imageDisplay ??
                      (editVenue?.id && editVenue?.image !== ''
                        ? editVenue?.image
                        : categoryImagePlaceholder)
                    }
                    style={{height: '110px'}}
                  />
                </div>
              </div>
              {Boolean(validation.touched.image) &&
              Boolean(validation.errors.image) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.image}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>
          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Venue Name
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.VenueName} />
              </div>
              <Form.Control
                type="text"
                id="venue-name"
                placeholder="Enter Venue Name"
                name="name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.name || editVenue?.name
                    ? editVenue?.name
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.name) &&
                    Boolean(validation.errors.name)
                  )
                }
              />
              {Boolean(validation.touched.name) &&
              Boolean(validation.errors.name) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.name}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">Status</Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.VenueStatus} />
              </div>
              <Form.Select
                className="form-select"
                name="is_active"
                id="status-Field"
                onChange={e =>
                  validation.setFieldValue('is_active', e.target.value)
                }
                value={
                  validation.values.is_active ||
                  (editVenue?.is_active !== '' ? editVenue?.is_active : '')
                }
                isInvalid={
                  !!(
                    validation.touched.is_active && validation.errors.is_active
                  )
                }>
                <option value=" ">Status</option>
                {status?.map((data: CategoryStatusList, i) => (
                  <option key={i} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>

              {Boolean(validation.touched.is_active) &&
              Boolean(validation.errors.is_active) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.is_active}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12} className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <Button
                role="submitCategory"
                variant="dark"
                id="add-btn"
                type="submit">
                {editVenue?.id !== undefined ? 'Edit Venue' : 'Add Venue'}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SuggestedVenueForm;
